import { useEffect } from "react";
import BrowserComponent from "./BroswerComponent";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootUrl } from "../../redux/types";

// Splits KOT items into one group (= one printed KOT) per mapping row, plus
// one for the default KOT printer. Rows are never merged, even when they use
// the same printer, so 3 rows on one printer print 3 separate KOTs. An item
// goes to every row whose categories include its category; items matching no
// row go to the default printer.
const getPrinterGroups = (items = [], mappings = [], defaultPrinter) => {
  const validMappings = (mappings || []).filter(
    (m) => m?.printer && m.categories?.length > 0,
  );
  const defaultItems = [];
  const mappingItems = validMappings.map(() => []);

  items.forEach((item) => {
    let matchedAny = false;
    validMappings.forEach((m, i) => {
      const matches = m.categories.some(
        (c) =>
          (c.id && item.categoryId && c.id === String(item.categoryId)) ||
          (c.name && item.categoryName && c.name === item.categoryName),
      );
      if (matches) {
        mappingItems[i].push(item);
        matchedAny = true;
      }
    });
    if (!matchedAny) defaultItems.push(item);
  });

  return [
    { printer: defaultPrinter, items: defaultItems },
    ...validMappings.map((m, i) => ({
      printer: m.printer,
      items: mappingItems[i],
    })),
  ].filter((g) => g.items.length > 0);
};

const KOTPrintComponent = (props) => {
  const isElectron = window?.api?.isElectron;

  const {
    KOTprintData,
    enableKOT,
    enableLogo,
    enableBranchName,
    enableAddress,
    enableGSTNumber,
    enableCustomer,
    kotPrinter,
    kotPrinterMappings,
    printKOTTokenSlip,
  } = useSelector((state) => state.util);

  const menuItems = useSelector((state) => state.branch.items) || [];

  const printSetting = {
    enableLogo,
    enableBranchName,
    enableAddress,
    enableGSTNumber,
    enableCustomer,
    kotPrinter,
  };

  const logo = RootUrl + "/" + useSelector((state) => state.user.logo);

  const { branchName, branchAddress } = useSelector((state) => state.user);

  const restaurant = `${branchName && enableBranchName ? `${branchName}` : ""}`;

  useEffect(() => {
    console.log("window kot", KOTprintData);
    if (isElectron && KOTprintData) {
      const {
        branchOrderNumber,
        customerMobile,
        customerName,
        orderDate,
        orderItems,
        orderType,
        remarks,
        tableNumber,
        totalQuantity,
      } = KOTprintData;
      const lastKot = KOTprintData.KOTS[KOTprintData.KOTS.length - 1];

      // KOT items may have lost their category on the way (older items, or a
      // server that strips fields), so resolve it from the loaded menu.
      const itemsWithCategory = lastKot.orderItems.map((item) => {
        if (item.categoryId || item.categoryName) return item;
        const menuItem = menuItems.find((m) =>
          [item._id, item.id, item.itemId].some(
            (id) => id && [m._id, m.id].includes(id),
          ),
        );
        return menuItem
          ? {
              ...item,
              categoryId: menuItem.categoryId,
              categoryName: menuItem.categoryName,
            }
          : item;
      });

      const groups = getPrinterGroups(
        itemsWithCategory,
        kotPrinterMappings,
        kotPrinter,
      );
      console.log(
        "KOT routing",
        { kotPrinter, kotPrinterMappings },
        groups.map((g) => ({
          printer: g.printer,
          items: g.items.map((i) => `${i.itemName} [${i.categoryName}]`),
        })),
      );

      groups.forEach(
        ({ printer, items }) => {
          window.api.printKOTSilently({
            logo,
            printData: {
              branchOrderNumber,
              customerMobile,
              customerName,
              orderDate: moment().format("DD/MM/YYYY HH:mm"),
              orderItems: items,
              orderType,
              remarks,
              tableNumber,
              totalQuantity,
              kotNumber: lastKot.kotNumber,
            },
            restaurant,
            branchAddress,
            printSetting: { ...printSetting, kotPrinter: printer },
          });
        },
      );

      // Parcel orders also get a separate paper with just the token number.
      if (orderType === "Parcel" && printKOTTokenSlip) {
        window.api.printKOTSilently({
          logo,
          printData: {
            orderType,
            kotNumber: lastKot.kotNumber,
            tokenSlip: true,
          },
          restaurant,
          branchAddress,
          printSetting: { ...printSetting, kotPrinter },
        });
      }
    }
  }, [KOTprintData, enableKOT]);

  return !enableKOT ? (
    <div />
  ) : isElectron ? (
    <div />
  ) : (
    <BrowserComponent
      printData={KOTprintData}
      logo={enableLogo && logo}
      restaurant={restaurant}
      branchAddress={enableAddress && branchAddress}
    />
  );
};

export default KOTPrintComponent;
